import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import clsx from 'clsx'

import { Edit16, Reorder16, Trash16 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonVariant } from '@makyoapp/makyo-ui'

export interface SortableItemProps {
  id: string
  icon?: React.ReactNode
  title?: React.ReactNode
  wrapTitle?: boolean
  children?: React.ReactNode
  reorderTitle?: string
  onEdit?: () => void
  editTitle?: string
  onDelete?: () => void
  deleteTitle?: string
  onClick?: () => void
  itemClassName?: string
  noBg?: boolean
  className?: string
  deleteAtEnd?: boolean
  titleClassName?: string
}

export function SortableItem({
  id,
  icon,
  title,
  reorderTitle,
  onClick,
  onEdit,
  wrapTitle = true,
  editTitle,
  onDelete,
  deleteTitle,
  className,
  itemClassName,
  noBg = false,
  children,
  deleteAtEnd = true,
  titleClassName,
}: SortableItemProps) {
  const { attributes, listeners, setNodeRef, transition, transform } = useSortable({
    id,
  })

  const delBtn = (
    <Button
      variant={ButtonVariant.Ghost}
      className={clsx(!noBg && 'hover:text-primary-500!', 'shrink-0')}
      icon={<Trash16 />}
      noPadding
      squared
      onClick={onDelete}
      title={deleteTitle}
      noTip
    />
  )

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
    >
      <div
        className={clsx(
          'flex items-center',
          !noBg && 'hover:bg-zinc-100 dark:hover:bg-slate-900 rounded-md',
          className
        )}
      >
        {title && (
          <div onClick={onClick} className={clsx('w-full px-2 h-10 txt flex-c')}>
            {icon}
            {wrapTitle ? <div className={clsx('txt', titleClassName)}>{title}</div> : title}
          </div>
        )}
        <div className={clsx('shrink-0 flex items-center ltr:pr-2 rtl:pl-2', itemClassName)}>
          {onEdit && (
            <Button
              variant={ButtonVariant.Ghost}
              icon={<Edit16 />}
              className='hover:text-primary-500!'
              noPadding
              squared
              title={editTitle}
              onClick={onEdit}
              noTip
            />
          )}
          {!deleteAtEnd && onDelete && delBtn}
          {children}
          {deleteAtEnd && onDelete && delBtn}
          <div {...listeners}>
            <Button
              variant={ButtonVariant.Ghost}
              className={clsx(!noBg && 'hover:text-primary-500!', 'shrink-0')}
              icon={<Reorder16 />}
              noPadding
              squared
              title={reorderTitle}
              noTip
            />
          </div>
        </div>
      </div>
    </div>
  )
}
